'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusChild = exports.focusFirstChild = exports.returnFocus = exports.focusLater = undefined;

var _tabbable = require('./tabbable');

var lastFocusedElement = undefined;

var focusLater = exports.focusLater = function focusLater() {
  lastFocusedElement = document.activeElement;
};

var returnFocus = exports.returnFocus = function returnFocus() {
  if (lastFocusedElement) {
    lastFocusedElement.focus();
    lastFocusedElement = null;
  }
};

var focusFirstChild = exports.focusFirstChild = function focusFirstChild(element) {
  var tabbable = (0, _tabbable.setTabbable)(element);
  tabbable.first.focus();
};

var focusChild = exports.focusChild = function focusChild(parent, selector) {
  var child = document.querySelector(selector);

  if (!parent.contains(child)) {
    console.error(selector + ' is not a child of the specified parent.'); // eslint-disable-line

    return;
  }

  child.focus();
};